import {useState, useMemo, useCallback} from "react";
import _ from "lodash";
import {CROPS} from "../utils/enumItemsUtils";

interface ItemWithId {
    id: string;
}

export function useFilter<T extends ItemWithId>(globalItems: T[], idProperty: keyof T) {
    const [selectedOption, setSelectedOption] = useState<string>("All");

    const options = useMemo(() => {
        const uniqueIds = _.uniqBy(globalItems, idProperty)
            .map((item) => item[idProperty])
            .filter((item) => item) as string[];
        return ["All", ...uniqueIds];
    }, [globalItems, idProperty]);

    const filterFn = useCallback(
        (item: string | null) => selectedOption === "All" || item === selectedOption,
        [selectedOption],
    );

    return {options, selectedOption, setSelectedOption, filterFn};
}

export function useCropFilter() {
    const [selectedOption, setSelectedOption] = useState<string>("All");

    const options = ["All", ...new Set(CROPS.map((item) => item.id))];

    const filterFn = useCallback(
        (item: string | null) => selectedOption === "All" || item === selectedOption,
        [selectedOption],
    );

    return {options, selectedOption, setSelectedOption, filterFn};
}
